import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import FileCardButton from "../../../Components/UI/FileCardButton/FileCardButton";

import { addNotification } from "../../../store/actions/notifierActions";
import { RequestManualWatermarkDecode } from "../../../store/actions/watermarkDecoderActions";

const ManualDecode = () => {
  const dispatch = useDispatch();

  const manualResult = useSelector((state) => state.watermarkDecoder.manualResult);
  const manualLoading = useSelector((state) => state.watermarkDecoder.manualLoading);

  const [watermarkString, setWatermarkString] = useState("");

  const submitHandler = (e) => {
    e.preventDefault();
    const trimmed = watermarkString.trim();
    if (!trimmed) {
      dispatch(
        addNotification({
          message: "Please enter a watermark string.",
          options: { variant: "error" },
        }),
      );
      return;
    }
    dispatch(RequestManualWatermarkDecode({ watermarkString: trimmed }));
  };

  return (
    <div className="watermark-decoder__manual border">
      <h3>Manual Watermark Decode</h3>
      <p className="watermark-decoder__help-text">
        If OCR results are unclear or you already have the text, enter the watermark string you read
        from the image.
      </p>

      <form className="watermark-decoder__manual__form" onSubmit={submitHandler}>
        <input
          type="text"
          className="watermark-decoder__text-input"
          placeholder="Example: xxxxxxxxx-yyyyyyy-1738999999-zz"
          value={watermarkString}
          onChange={(e) => setWatermarkString(e.target.value)}
        />
        <FileCardButton onClick={submitHandler}>
          <p>{manualLoading ? "Decoding..." : "Decode"}</p>
        </FileCardButton>
      </form>

      {manualResult && (
        <div className="watermark-decoder__result-card">
          <h4>Decode Result</h4>
          <div className="watermark-decoder__result-item">
            <span className="watermark-decoder__result-label">Username:</span>
            <span className="watermark-decoder__result-value">
              {manualResult.username || "N/A"}
            </span>
          </div>
          <div className="watermark-decoder__result-item">
            <span className="watermark-decoder__result-label">Computer Name:</span>
            <span className="watermark-decoder__result-value">
              {manualResult.computername || "N/A"}
            </span>
          </div>
          <div className="watermark-decoder__result-item">
            <span className="watermark-decoder__result-label">Epoch Hour:</span>
            <span className="watermark-decoder__result-value">
              {manualResult.epochhour || "N/A"}
            </span>
          </div>
          <div className="watermark-decoder__result-item">
            <span className="watermark-decoder__result-label">Readable Time:</span>
            <span className="watermark-decoder__result-value watermark-decoder__table__highlight">
              {manualResult.timestamp || "N/A"}
            </span>
          </div>
          <div className="watermark-decoder__result-item">
            <span className="watermark-decoder__result-label">Login Method:</span>
            <span className="watermark-decoder__result-value">
              {manualResult.loginmethod || "N/A"}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManualDecode;
